/* eslint-disable react/destructuring-assignment */
import { getAuth } from 'firebase/auth'
import { errorReporter } from 'fitify-ui/src/utils/error-reporter'
import { type ReactNode, Component } from 'react'

interface Props {
  isProduction: boolean
  children?: ReactNode
}

interface State {
  hasError: boolean
  error: string
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
    error: '',
  }

  static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error: _.message }
  }

  componentDidCatch(error: Error) {
    if (this.props.isProduction) {
      const firebaseAuth = getAuth()

      if (firebaseAuth.currentUser) {
        errorReporter.setUser(firebaseAuth.currentUser.uid)
      }
      void errorReporter.report(error)
    }
  }

  render() {
    if (this.state.hasError) {
      return <h1>Sorry.. there was an error</h1>
    }

    return this.props.children
  }
}
